import { Participant } from 'livekit-client';
import { ParticipantReaction, Reaction } from '../../features/Reactions';
import { reactionsStore } from '../store';

export const selectReactions = (): Reaction[] => {
    return reactionsStore.reactions;
};

export const selectParticipantReaction = (participant: Participant): ParticipantReaction | null => {
    return reactionsStore.getParticipantReaction(participant);
};
